import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const clienteService = {
  getAllFilter,
  syncClienteFromPipeDrive,
  insertOrUpdate,
}

async function getAllFilter(findCliente) {
  return await ApiBudgety.post('Cliente/GetAllFilter/', findCliente)
}

async function syncClienteFromPipeDrive() {
  return await ApiBudgety.get('Cliente/SyncClienteFromPipeDrive/')
}

async function insertOrUpdate(client) {
  return await ApiBudgety.post('Cliente/InsertOrUpdate/', client)
}
